import axios from 'axios'
import {BUSCAR_MAPA_VEICULO_ITINERARIO} from '../types'
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil'
import {URL} from '../../util/ambienteActions';

export default function buscarMapaVeiculoItinerario(empresaId, codigoItinerario) {
    const url = `${URL}/mapas-veiculos/bloqueio-poltrona/empresa/${empresaId}/itinerario/${codigoItinerario}`;
    return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: BUSCAR_MAPA_VEICULO_ITINERARIO,
            payload: response

        })
    );
}
